export default "__VITE_ASSET__DEOA499p__"